// extracted by mini-css-extract-plugin
export default {"SlimBox":"AnalyticButton_SlimBox__suV+S","Bar":"AnalyticButton_Bar__Om+Cq","SingleBox":"AnalyticButton_SingleBox__NIu+z"};